import React, { useContext } from 'react';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import { loadImage } from '../../../../../lib/utils/utils';
import { v4 as uuidv4 } from 'uuid';
import AddImage from '../../../../../Assets/Add image.svg';
import { showToast } from '../../../../../Components/Toaster/Toaster';

function ImageInput({ errorText }) {
    const {
        singleBanner,
        setSingleBanner,
    } = useContext(StorefrontContext);

    async function handleImageChange(e) {
        const file = e.target.files[0];

        if(file) {
            const img = await loadImage(file);
            if ((img.width > 1080 || img.height > 1080) || (img.width/img.height !== 1)) {
                showToast('Please select image of resolution 1080*1080', 'warning');
            }
            else {
                const selectedImage = {
                    id: uuidv4(),
                    url: img.src,
                    file: file,
                }
    
                setSingleBanner({
                    ...singleBanner,
                    image: selectedImage,
                });
            }
        }

        e.target.value = null;
    }

    return (
        <div className='flex flex-col gap-2'>
            <div className="flex items-center justify-between">
                <p className='font-medium text-[14px] leading-6 text-[#121212]'>Banner Image <span className='text-[12px] text-[#666666]'>&#40;1080px * 1080px&#41;</span></p>

                <p className='text-[12px] leading-5 text-[#EF4444]'>{errorText}</p>
            </div>

            <div className="flex items-center gap-3">
                {
                    singleBanner.image.url ? 
                    <div className="size-[100px] rounded-lg overflow-hidden">
                        <img className='size-full object-cover' src={singleBanner.image.url} alt="" />
                    </div> : 
                    <label htmlFor="banner-image" className="cursor-pointer size-[100px] rounded-lg overflow-hidden bg-[#666666] flex items-center justify-center">
                        <img className='size-1/2' src={AddImage} alt="" />
                    </label>
                }

                <input 
                    id='banner-image' 
                    name='banner-image' 
                    className='hidden'
                    type="file" 
                    accept='image/*' 
                    onChange={handleImageChange} 
                />

                <label htmlFor='banner-image' className='outline-none px-4 py-[6px] rounded-md bg-primaryColor hover:bg-primaryAccent font-semibold text-[12px] leading-6 text-buttonText cursor-pointer'>Change Image</label>
            </div>
        </div>
    );
}

export default ImageInput;
